/** Launch cockpit help — EN (7 steps + overview). */

const stepTemplate = (number, objective, actions, expected, next) => ({
  key: `launch-cockpit-step-${number}`,
  screenLabel: `Launch cockpit — Step ${number}`,
  purpose: objective,
  actions,
  warning: expected,
  nextStep: next,
});

/** @type {Record<string, object>} */
export const helpTopicsLaunchCockpitEn = {
  "launch-cockpit": {
    key: "launch-cockpit",
    screenLabel: "September 1 launch cockpit",
    purpose: "Steer official September 1, 2026 opening prep without a heavy project-management tool.",
    actions: [
      "Read the summary: countdown, progress, deadline status, active step.",
      "Check “Do now” (max 3 priorities).",
      "Open a timeline step to review outcomes and update statuses.",
      "Review the “Ready for September 1?” checklist.",
    ],
    warning: "Never mark Done without real verification in the app.",
    nextStep: "Open the active step for the detailed guide (Help button updates).",
  },
  ...Object.fromEntries(
    [
      stepTemplate(
        1,
        "Stabilize V1 core: auth, accounts, dojos, instructors, members on PostgreSQL.",
        ["Validate each R0 module in the browser (5174).", "Keep To validate until phase1 is wired.", "Do not start parent flows before core is stable."],
        "Auth, instructors and members Done or To validate with evidence.",
        "Step 2 — member / parent journey.",
      ),
      stepTemplate(
        2,
        "Full member and parent journey (sign-in, profile, child info, schedule).",
        ["Test parent and student sign-in (non-demo if possible).", "List screens still on localStorage.", "Log blockers in the cockpit."],
        "Parent and student can complete the minimal journey.",
        "Step 3 — dojo administration.",
      ),
      stepTemplate(
        3,
        "Dojo admin: members, parents, groups, schedule, attendance.",
        ["Confirm R0 members in dev.", "Decide V1 scope for groups and schedule.", "Update “Waiting on…” dependencies."],
        "Hanshi and Sensei can manage their scope without dead zones.",
        "Step 4 — real-world tests.",
      ),
      stepTemplate(
        4,
        "Real tests on full desktop and mobile journeys.",
        ["Run npm test + browser validation on 5174.", "Document gaps in the cockpit.", "Verify persistence after refresh."],
        "All critical journeys tested and statuses current.",
        "Step 5 — blocking fixes only (V1 freeze).",
      ),
      stepTemplate(
        5,
        "Blocking fixes only — freeze on new V1 features.",
        ["Reject non-critical additions.", "Fix only what blocks real use.", "Update launch checklist."],
        "No open blockers; dead links fixed or hidden.",
        "Step 6 — final production.",
      ),
      stepTemplate(
        6,
        "Final production: deploy, seeds, prod validation.",
        ["Deploy frontend + backend.", "Run seeds.", "Validate health and Hanshi flows in prod."],
        "Production validated with semver and automated checks.",
        "Step 7 — official opening.",
      ),
      stepTemplate(
        7,
        "Official opening September 1, 2026.",
        ["Confirm checklist critical items.", "Communicate go/no-go.", "Monitor day-one support."],
        "“KARATÉ IS READY TO OPEN” message shown.",
        "Phase 2 — post-launch ideas in the cockpit.",
      ),
    ].map((t) => [t.key, t]),
  ),
};
